import resource from '../resource';

//create ,get ,query ,remove & update
export const signin = resource('/user/login');
export const signUpApi = resource('/user/sign-up');
export const storesApi = resource('/user/stores');
export const forgotPasswordApi = resource('user/recover-password/');
export const resetPasswordApi = resource('user/reset-password/');
export const registerFCMTokenApi = resource('app/register/');
